<template>
  <v-select
    :items="items"
    :model-value="modelValue"
    @update:model-value="emit('update:modelValue', $event)"
    density="comfortable"
    :label="$t('general.month')"
    hide-details
    item-title="title"
    item-value="value"
    :item-props="true"
  />
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  modelValue: { type: Number, default: null },     // 1–12 nebo null
  available:  { type: Array,  default: null },     // když null → vše povoleno
})
const emit = defineEmits(['update:modelValue'])
const { t } = useI18n()

const keyFor = (m) => [
  null,'january','february','march','april','may','june',
  'july','august','september','october','november','december'
][m]

const items = computed(() => {
  // null → prop neposlán → vše povoleno
  const allowAll = props.available == null
  const allowedSet = allowAll ? null : new Set((props.available || []).map(Number))

  return Array.from({ length: 12 }, (_, i) => {
    const m = i + 1
    const isEnabled = allowAll ? true : allowedSet.has(m) // prázdné [] => vše disabled
    return {
      title: t(`enums.months.${keyFor(m)}`),
      value: m,
      disabled: !isEnabled,
    }
  })
})
</script>